import React, { useMemo } from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { TCountsOfGeneralSeaAreas } from '../../../kpiTypes';
import { formatValueAsString } from '../../../../../utils/helpers';
import { ChartContainer } from '../../../../../shared/components/charts/ChartContainer';
import { getSeaAreaColor } from '../../../../../utils/chartColorRegistry';

export interface IOperationalPhaseChartProps {
	data: TCountsOfGeneralSeaAreas[];
}

const GeneralSeaAreasChart: React.FC<IOperationalPhaseChartProps> = ({ ...props }) => {
	const formatOptions: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 1 };

	const data = Array.isArray(props.data) ? props.data : ([] as TCountsOfGeneralSeaAreas[]);

	const options = useMemo<AgChartOptions>(() => ({
		series: [
			{
				data: data,
				type: 'pie',
				calloutLabelKey: 'generalSeaArea',
				angleKey: 'percentageOfTotal',
				calloutLabel: {
					avoidCollisions: true,
					formatter: ({ datum, angleKey }) => formatValueAsString(datum[angleKey], formatOptions, '', '', '%'),
				},
				calloutLine: {
					colors: props.data
						? props.data.map((item) => getSeaAreaColor(item.generalSeaArea))
						: ['#000000', '#000000', '#000000', '#000000'],
				},
				tooltip: {
					renderer: ({ datum, angleKey, calloutLabelKey = 'generalSeaArea' }) => ({
						data: undefined,
						title: `${datum[calloutLabelKey]}`,
						heading: formatValueAsString(datum[angleKey], formatOptions, '', '', '%'),
					}),
				},
				fills: props.data ? props.data.map((item) => getSeaAreaColor(item.generalSeaArea)) : [],
			},
		],
		legend: {
			position: 'right',
			item: {
				label: {
					formatter: (params) => {
						const item = props.data.find((_, index) => index === params.itemId);
						return item ? item.generalSeaArea : params.itemId;
					},
				},
			},
		},
	}), [props.data, data]);

	const downloadableData = data.map((item) => ({
		generalSeaArea: item.generalSeaArea,
		percentageOfTotal: item.percentageOfTotal
	}));

	return (
		<ChartContainer
			data={downloadableData}
			filename="general_sea_areas_data"
			buttonPosition="top-right"
		>
			<AgCharts options={options} className="w-full h-full" />
		</ChartContainer>
	);
};

export default GeneralSeaAreasChart;
